//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useWriteOffReminderFeeDialog() {
  const dispatch = useDispatch();

  const writeOffReminderFeeDialog = (amount: string, onConfirm: () => Promise<any>): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.WriteOffReminderFeeConfirmTitle),
    titleIcon: IconDefinitionConstants.WMoney,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.WriteOffReminderFee),
        onClick: onConfirm,
      },
    ],
    dialogType: DialogEnums.DialogType.Message,
    children: LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Invoice.WriteOffReminderFeeConfirmDescription,
      "",
      { amount }
    ),
    maxWidth: "xs"
  });

  const showWriteOffReminderFeeDialog = (amount: string, onConfirm: () => Promise<any>) => {
    dispatch(displayDialog(writeOffReminderFeeDialog(amount, onConfirm)));
  };

  return { showWriteOffReminderFeeDialog };
}

export default useWriteOffReminderFeeDialog;
